import { Injectable } from '@angular/core';
import { COLLECTIONS } from '../../core.constants';
import { Id } from '../../models/common.model';
import { FirestoreService } from '../firestore.service';
import { shareReplay, Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsMasterService {
  settings$ = this.firestore
    .getDocument<any>(COLLECTIONS.MASTERS, COLLECTIONS.MASTERS_SETTINGS_DOC)
    .pipe(shareReplay(1));

  constructor(private firestore: FirestoreService) {}

  getSetting(id: Id): Observable<any> {
    return this.settings$.pipe(map((settings) => settings[id]));
  }
}
